
import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';
import { roleGuard } from './core/auth/role.guard';
import { ActivateAccountComponent } from './features/activate-account/activate-account.component';
import { ResetPasswordComponent } from './features/reset-password/reset-password.component';
import { GfcoreRouteComponent } from './features/gfcore-route/gfcore-route.component';
import { AppDefaultRedirectComponent } from './features/app-default-redirect/app-default-redirect.component';
import { ForbiddenComponent } from './features/forbidden/forbidden.component';
import { BackofficeShellComponent } from './features/backoffice/backoffice-shell.component';
import { BackofficeUsersPageComponent } from './features/backoffice/users-page.component';
import { BackofficeCompaniesPageComponent } from './features/backoffice/companies-page.component';
import { BackofficePlansPageComponent } from './features/backoffice/plans-page.component';
import { BackofficePricingPageComponent } from './features/backoffice/pricing-page.component';
import { LandingComponent } from './features/landing/landing.component';
import { CheckoutSuccessComponent } from './features/landing/checkout-success.component';
import { BackofficeHomeRedirectComponent } from './features/backoffice/backoffice-home-redirect.component';
import { LegalRedirectComponent } from './features/legal/legal-redirect.component';

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'pricing', component: LandingComponent, data: { focusSection: 'pricing' } },
  { path: 'contact', component: LandingComponent, data: { focusSection: 'contact' } },
  { path: 'privacy-policy', component: LegalRedirectComponent, data: { legalDoc: 'privacy' } },
  { path: 'terms-of-service', component: LegalRedirectComponent, data: { legalDoc: 'terms' } },
  { path: 'success', component: CheckoutSuccessComponent },
  { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
  { path: 'activate-account', component: ActivateAccountComponent, canActivate: [guestGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [guestGuard] },
  { path: 'admin', pathMatch: 'full', redirectTo: 'app/admin' },
  { path: 'backoffice', pathMatch: 'full', redirectTo: 'app/admin' },
  { path: 'forge-agentic/workflow', pathMatch: 'full', redirectTo: 'app/ci-cd/workflow' },
  { path: 'forge-agentic/review', pathMatch: 'full', redirectTo: 'app/ci-cd/review' },
  { path: 'forbidden', component: ForbiddenComponent },
  {
    path: 'app',
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', component: AppDefaultRedirectComponent },
      {
        path: 'ci-cd/workflow',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'agentic-workflow-page' }
      },
      {
        path: 'ci-cd/review',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'agentic-review-page' }
      },
      {
        path: 'agentic/workflow',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'agentic-workflow-page' }
      },
      {
        path: 'agentic/review',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'agentic-review-page' }
      },
      { path: 'forge-agentic/workflow', pathMatch: 'full', redirectTo: 'ci-cd/workflow' },
      { path: 'forge-agentic/review', pathMatch: 'full', redirectTo: 'ci-cd/review' },
      {
        path: 'builder/generate',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'build-generate-page' }
      },
      {
        path: 'builder/improve',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'build-improve-page' }
      },
      {
        path: 'builder/implementation',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'build-implementation-page' }
      },
      {
        path: 'audit/workspace',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'audit-mode-page' }
      },
      {
        path: 'audit/challenge',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'build-challenge-requirement-page' }
      },
      {
        path: 'integrations',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'integrations-page' }
      },
      {
        path: 'integrations/jira',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'integrations-jira-page' }
      },
      {
        path: 'integrations/squash',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'integrations-squash-page' }
      },
      {
        path: 'integrations/gitlab',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'integrations-gitlab-page' }
      },
      {
        path: 'docs/risk-tags',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'risk-tags-docs-page' }
      },
      {
        path: 'docs/audit-scoring',
        component: GfcoreRouteComponent,
        data: { gfcorePage: 'audit-scoring-docs-page' }
      },
      {
        path: 'admin',
        canActivate: [roleGuard],
        data: { roles: ['admin', 'superadmin'] },
        component: BackofficeShellComponent,
        children: [
          { path: '', pathMatch: 'full', component: BackofficeHomeRedirectComponent },
          { path: 'users', component: BackofficeUsersPageComponent },
          {
            path: 'compagnies',
            component: BackofficeCompaniesPageComponent,
            canActivate: [roleGuard],
            data: { roles: ['superadmin'] }
          },
          {
            path: 'plans',
            component: BackofficePlansPageComponent,
            canActivate: [roleGuard],
            data: { roles: ['superadmin'] }
          },
          { path: 'licences', component: BackofficePricingPageComponent },
          { path: 'chiffrage', component: BackofficePricingPageComponent }
        ]
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
